module.exports = __webpack_public_path__ + "/public/images/7640146c80040eeb1feb3dd223fc591d.png";